import React from "react";

import styles from "./Switch.local.scss";

export default function Switch({ name, checked, onChange }) {
  return (
    <label>
      <input
        name={name}
        checked={checked}
        onChange={({ target }) => onChange(target.checked)}
        className={styles.switch}
        type="checkbox"
      />
      <div>
        <span>
          <g className="icon icon-toolbar grid-view" />
        </span>
        <span>
          <g className="icon icon-toolbar ticket-view" />
        </span>
        <div />
      </div>
    </label>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/Switch/Switch.js